import { useCallback } from 'react';

import { usePlanReactivationModalStore } from '../stores';

interface UsePlanReactivationModalReturn {
  openSingleReactivation: (planId: string, planName?: string, additionalAction?: () => void) => void;
  openBulkReactivation: (additionalAction?: () => void) => void;
}

export const usePlanReactivationModal = (): UsePlanReactivationModalReturn => {
  const handleSetPlanId = usePlanReactivationModalStore((state) => state.handleSetPlanId);
  const handleSetPlanName = usePlanReactivationModalStore((state) => state.handleSetPlanName);
  const handleSetIsBulkMode = usePlanReactivationModalStore((state) => state.handleSetIsBulkMode);
  const handleSetAdditionalAction = usePlanReactivationModalStore((state) => state.handleSetAdditionalAction);
  const handleChangeVisibility = usePlanReactivationModalStore((state) => state.handleChangeVisibility);

  const openSingleReactivation = useCallback((
    planId: string, 
    planName?: string, 
    additionalAction?: () => void
  ) => {
    handleSetPlanId(planId);
    if (planName) {
      handleSetPlanName(planName);
    }
    handleSetIsBulkMode(false);
    if (additionalAction) {
      handleSetAdditionalAction(additionalAction);
    }
    handleChangeVisibility(true);
  }, [handleSetPlanId, handleSetPlanName, handleSetIsBulkMode, handleSetAdditionalAction, handleChangeVisibility]);

  const openBulkReactivation = useCallback((
    additionalAction?: () => void
  ) => {
    handleSetIsBulkMode(true);
    if (additionalAction) {
      handleSetAdditionalAction(additionalAction);
    }
    handleChangeVisibility(true);
  }, [handleSetIsBulkMode, handleSetAdditionalAction, handleChangeVisibility]);

  return {
    openSingleReactivation,
    openBulkReactivation,
  };
};